import { css } from '@emotion/react';
import { SpacingToken } from '@livechat/design-system-react-components';
import { MEDIA_MIN_SM } from '_assets/css/breakpoints';

export const loaderContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export const container = css`
  display: flex;
  flex-direction: column;
  gap: var(${SpacingToken.Spacing6});
  padding: 0 var(${SpacingToken.Spacing5});
  margin-top: 56px;
  width: 100%;
  max-width: 400px;

  ${MEDIA_MIN_SM} {
    margin-top: 118px;
  }
`;

export const formField = css`
  width: 100%;
`;

export const passwordField = css`
  width: 100%;
  margin-bottom: var(${SpacingToken.Spacing3});
`;

export const button = css`
  width: 100%;
`;

export const submitingContainer = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(${SpacingToken.Spacing3});
  padding: 0 var(${SpacingToken.Spacing5});
  margin-top: 168px;
`;
